import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import VueNativeSock from 'vue-native-websocket'
import * as VueGoogleMaps from 'vue2-google-maps'
import router from './router'
import store from './store'
import App from './App.vue'
import './filters/filters'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

Vue.prototype.$stateTranslate = i18n
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(VueNativeSock, '', {
  connectManually: true,
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5000,
  reconnectionDelay: 300,
})

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyBWZtixfdDnconRv4NCCxqv3Xro4pZvwyk',
    libraries: 'places', // This is required if you use the Auto complete plug-in
    region: 'th',
    language: 'th',
  },
})

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
